/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserCreditsSlimStatusTierThresholds } from './UserCreditsSlimStatusTierThresholds';
import {
    UserCreditsSlimStatusTierThresholdsFromJSON,
    UserCreditsSlimStatusTierThresholdsFromJSONTyped,
    UserCreditsSlimStatusTierThresholdsToJSON,
    UserCreditsSlimStatusTierThresholdsToJSONTyped,
} from './UserCreditsSlimStatusTierThresholds';
import type { StatusChallengeStats } from './StatusChallengeStats';
import {
    StatusChallengeStatsFromJSON,
    StatusChallengeStatsFromJSONTyped,
    StatusChallengeStatsToJSON,
    StatusChallengeStatsToJSONTyped,
} from './StatusChallengeStats';
import type { UserRewardLedgerEntry } from './UserRewardLedgerEntry';
import {
    UserRewardLedgerEntryFromJSON,
    UserRewardLedgerEntryFromJSONTyped,
    UserRewardLedgerEntryToJSON,
    UserRewardLedgerEntryToJSONTyped,
} from './UserRewardLedgerEntry';
import type { WelcomeBackOffer } from './WelcomeBackOffer';
import {
    WelcomeBackOfferFromJSON,
    WelcomeBackOfferFromJSONTyped,
    WelcomeBackOfferToJSON,
    WelcomeBackOfferToJSONTyped,
} from './WelcomeBackOffer';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 *
 * @export
 * @interface UserCreditsSlim
 */
export interface UserCreditsSlim {
    /**
     *
     * @type {WelcomeBackOffer}
     * @memberof UserCreditsSlim
     */
    welcomeBackOffer?: WelcomeBackOffer;
    /**
     * This user's referral code which can be used to make referrals.
     * @type {string}
     * @memberof UserCreditsSlim
     */
    referralCode?: string | null;
    /**
     *
     * @type {number}
     * @memberof UserCreditsSlim
     */
    cashbackPercentage?: number;
    /**
     * The number of Gondola bookings.
     * @type {number}
     * @memberof UserCreditsSlim
     */
    gondolaBookingsCount?: number;
    /**
     *
     * @type {CurrencyAmount}
     * @memberof UserCreditsSlim
     */
    totalGondolaCash?: CurrencyAmount;
    /**
     *
     * @type {CurrencyAmount}
     * @memberof UserCreditsSlim
     */
    pendingEarnings?: CurrencyAmount;
    /**
     *
     * @type {CurrencyAmount}
     * @memberof UserCreditsSlim
     */
    potentialEarnings?: CurrencyAmount;
    /**
     * The number of Gondola bookings in the current year.
     * @type {number}
     * @memberof UserCreditsSlim
     */
    currentYearBookingCount?: number;
    /**
     * The number of Gondola bookings in the current year, including pending bookings.
     * @type {number}
     * @memberof UserCreditsSlim
     */
    currentYearIncludingPendingBookingCount?: number;
    /**
     * The number of nights stayed in Gondola bookings in the current year.
     * @type {number}
     * @memberof UserCreditsSlim
     */
    currentYearNightsCount?: number;
    /**
     * The number of nights stayed in Gondola bookings in the current year, including pending bookings.
     * @type {number}
     * @memberof UserCreditsSlim
     */
    currentYearIncludingPendingNightsCount?: number;
    /**
     *
     * @type {CurrencyAmount}
     * @memberof UserCreditsSlim
     */
    currentYearTotalCostInUsd?: CurrencyAmount;
    /**
     *
     * @type {CurrencyAmount}
     * @memberof UserCreditsSlim
     */
    currentYearIncludingPendingTotalCostInUsd?: CurrencyAmount;
    /**
     * The number of referrals in the current year.
     * @type {number}
     * @memberof UserCreditsSlim
     */
    currentYearReferralsCount?: number;
    /**
     * The number of pending referrals in the current year.
     * @type {number}
     * @memberof UserCreditsSlim
     */
    currentYearPendingReferralsCount?: number;
    /**
     * If this user was referred by another user, the user ID of the referrer; null otherwise.
     * @type {string}
     * @memberof UserCreditsSlim
     */
    referredByUserId?: string | null;
    /**
     *
     * @type {string}
     * @memberof UserCreditsSlim
     */
    statusTier?: UserCreditsSlimStatusTierEnum;
    /**
     *
     * @type {Date}
     * @memberof UserCreditsSlim
     */
    statusTierExpirationDate?: Date;
    /**
     *
     * @type {StatusChallengeStats}
     * @memberof UserCreditsSlim
     */
    statusChallengeStats?: StatusChallengeStats;
    /**
     *
     * @type {UserCreditsSlimStatusTierThresholds}
     * @memberof UserCreditsSlim
     */
    statusTierThresholds?: UserCreditsSlimStatusTierThresholds;
    /**
     * The amount of credits (in USD) the current user earns per successful referral.
     * @type {number}
     * @memberof UserCreditsSlim
     */
    referralGetAmount?: number;
    /**
     * The amount of credits (in USD) a referred friend receives on their first qualifying booking.
     * @type {number}
     * @memberof UserCreditsSlim
     */
    referralGiveAmount?: number;
    /**
     *
     * @type {Array<UserRewardLedgerEntry>}
     * @memberof UserCreditsSlim
     */
    rewardLedger?: Array<UserRewardLedgerEntry>;
}


/**
 * @export
 */
export const UserCreditsSlimStatusTierEnum = {
    Member: 'member',
    Silver: 'silver',
    Gold: 'gold'
} as const;
export type UserCreditsSlimStatusTierEnum = typeof UserCreditsSlimStatusTierEnum[keyof typeof UserCreditsSlimStatusTierEnum];


/**
 * Check if a given object implements the UserCreditsSlim interface.
 */
export function instanceOfUserCreditsSlim(value: object): value is UserCreditsSlim {
    return true;
}

export function UserCreditsSlimFromJSON(json: any): UserCreditsSlim {
    return UserCreditsSlimFromJSONTyped(json, false);
}

export function UserCreditsSlimFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCreditsSlim {
    if (json == null) {
        return json;
    }
    return {

        'welcomeBackOffer': json['welcome_back_offer'] == null ? undefined : WelcomeBackOfferFromJSON(json['welcome_back_offer']),
        'referralCode': json['referral_code'] == null ? undefined : json['referral_code'],
        'cashbackPercentage': json['cashback_percentage'] == null ? undefined : json['cashback_percentage'],
        'gondolaBookingsCount': json['gondola_bookings_count'] == null ? undefined : json['gondola_bookings_count'],
        'totalGondolaCash': json['total_gondola_cash'] == null ? undefined : CurrencyAmountFromJSON(json['total_gondola_cash']),
        'pendingEarnings': json['pending_earnings'] == null ? undefined : CurrencyAmountFromJSON(json['pending_earnings']),
        'potentialEarnings': json['potential_earnings'] == null ? undefined : CurrencyAmountFromJSON(json['potential_earnings']),
        'currentYearBookingCount': json['current_year_booking_count'] == null ? undefined : json['current_year_booking_count'],
        'currentYearIncludingPendingBookingCount': json['current_year_including_pending_booking_count'] == null ? undefined : json['current_year_including_pending_booking_count'],
        'currentYearNightsCount': json['current_year_nights_count'] == null ? undefined : json['current_year_nights_count'],
        'currentYearIncludingPendingNightsCount': json['current_year_including_pending_nights_count'] == null ? undefined : json['current_year_including_pending_nights_count'],
        'currentYearTotalCostInUsd': json['current_year_total_cost_in_usd'] == null ? undefined : CurrencyAmountFromJSON(json['current_year_total_cost_in_usd']),
        'currentYearIncludingPendingTotalCostInUsd': json['current_year_including_pending_total_cost_in_usd'] == null ? undefined : CurrencyAmountFromJSON(json['current_year_including_pending_total_cost_in_usd']),
        'currentYearReferralsCount': json['current_year_referrals_count'] == null ? undefined : json['current_year_referrals_count'],
        'currentYearPendingReferralsCount': json['current_year_pending_referrals_count'] == null ? undefined : json['current_year_pending_referrals_count'],
        'referredByUserId': json['referred_by_user_id'] == null ? undefined : json['referred_by_user_id'],
        'statusTier': json['status_tier'] == null ? undefined : json['status_tier'],
        'statusTierExpirationDate': json['status_tier_expiration_date'] == null ? undefined : (new Date(json['status_tier_expiration_date'])),
        'statusChallengeStats': json['status_challenge_stats'] == null ? undefined : StatusChallengeStatsFromJSON(json['status_challenge_stats']),
        'statusTierThresholds': json['status_tier_thresholds'] == null ? undefined : UserCreditsSlimStatusTierThresholdsFromJSON(json['status_tier_thresholds']),
        'referralGetAmount': json['referral_get_amount'] == null ? undefined : json['referral_get_amount'],
        'referralGiveAmount': json['referral_give_amount'] == null ? undefined : json['referral_give_amount'],
        'rewardLedger': json['reward_ledger'] == null ? undefined : ((json['reward_ledger'] as Array<any>).map(UserRewardLedgerEntryFromJSON)),
    };
}

export function UserCreditsSlimToJSON(json: any): UserCreditsSlim {
    return UserCreditsSlimToJSONTyped(json, false);
}

export function UserCreditsSlimToJSONTyped(value?: UserCreditsSlim | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'welcome_back_offer': WelcomeBackOfferToJSON(value['welcomeBackOffer']),
        'referral_code': value['referralCode'],
        'cashback_percentage': value['cashbackPercentage'],
        'gondola_bookings_count': value['gondolaBookingsCount'],
        'total_gondola_cash': CurrencyAmountToJSON(value['totalGondolaCash']),
        'pending_earnings': CurrencyAmountToJSON(value['pendingEarnings']),
        'potential_earnings': CurrencyAmountToJSON(value['potentialEarnings']),
        'current_year_booking_count': value['currentYearBookingCount'],
        'current_year_including_pending_booking_count': value['currentYearIncludingPendingBookingCount'],
        'current_year_nights_count': value['currentYearNightsCount'],
        'current_year_including_pending_nights_count': value['currentYearIncludingPendingNightsCount'],
        'current_year_total_cost_in_usd': CurrencyAmountToJSON(value['currentYearTotalCostInUsd']),
        'current_year_including_pending_total_cost_in_usd': CurrencyAmountToJSON(value['currentYearIncludingPendingTotalCostInUsd']),
        'current_year_referrals_count': value['currentYearReferralsCount'],
        'current_year_pending_referrals_count': value['currentYearPendingReferralsCount'],
        'referred_by_user_id': value['referredByUserId'],
        'status_tier': value['statusTier'],
        'status_tier_expiration_date': value['statusTierExpirationDate'] == null ? value['statusTierExpirationDate'] : value['statusTierExpirationDate'].toISOString().substring(0,10),
        'status_challenge_stats': StatusChallengeStatsToJSON(value['statusChallengeStats']),
        'status_tier_thresholds': UserCreditsSlimStatusTierThresholdsToJSON(value['statusTierThresholds']),
        'referral_get_amount': value['referralGetAmount'],
        'referral_give_amount': value['referralGiveAmount'],
        'reward_ledger': value['rewardLedger'] == null ? undefined : ((value['rewardLedger'] as Array<any>).map(UserRewardLedgerEntryToJSON)),
    };
}

